var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1186_2598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1186_2598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 17.6347C4.0375 17.6347 3.85938 17.5628 3.71563 17.419C3.57188 17.2751 3.5 17.0969 3.5 16.8844C3.5 16.6718 3.57188 16.4937 3.71563 16.3501C3.85938 16.2065 4.0375 16.1347 4.25 16.1347H19.75C19.9625 16.1347 20.1406 16.2066 20.2843 16.3504C20.4281 16.4942 20.5 16.6724 20.5 16.885C20.5 17.0976 20.4281 17.2757 20.2843 17.4193C20.1406 17.5629 19.9625 17.6347 19.75 17.6347H4.25ZM4.25 12.7501C4.0375 12.7501 3.85938 12.6782 3.71563 12.5344C3.57188 12.3905 3.5 12.2123 3.5 11.9998C3.5 11.7872 3.57188 11.6091 3.71563 11.4655C3.85938 11.3219 4.0375 11.2501 4.25 11.2501H19.75C19.9625 11.2501 20.1406 11.322 20.2843 11.4658C20.4281 11.6096 20.5 11.7878 20.5 12.0004C20.5 12.213 20.4281 12.3911 20.2843 12.5347C20.1406 12.6783 19.9625 12.7501 19.75 12.7501H4.25ZM4.25 7.86545C4.0375 7.86545 3.85938 7.79355 3.71563 7.64973C3.57188 7.50593 3.5 7.32773 3.5 7.11513C3.5 6.90254 3.57188 6.72446 3.71563 6.58088C3.85938 6.43728 4.0375 6.36548 4.25 6.36548H19.75C19.9625 6.36548 20.1406 6.43739 20.2843 6.5812C20.4281 6.72502 20.5 6.90322 20.5 7.1158C20.5 7.3284 20.4281 7.50649 20.2843 7.65008C20.1406 7.79366 19.9625 7.86545 19.75 7.86545H4.25Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger-icon.2ba8392bfe30af28793542b04712e7d7.svg";
export { ForwardRef as ReactComponent };